// extracted by mini-css-extract-plugin
export default {"container":"group_container__kqbEJ","content":"group_content__2M5Ol"};